import { createStyles } from "@mantine/core";
import { HEALTH_INDICATOR_SIZE } from "./constants";
import { IHealthIndicatorProps } from "./types";
import { tokenize } from "@common/utils/string";

export const useStyles = createStyles(
  (theme, { health, size = HEALTH_INDICATOR_SIZE }: IHealthIndicatorProps) => {
    return {
      root: {
        backgroundColor: String(health).startsWith("#")
          ? health
          : theme.other.health[tokenize(health)] || "pink",
        borderRadius: size,
        display: "block",
        height: size,
        margin: 0,
        minHeight: size,
        minWidth: size,
        pointerEvents: "none",
        userSelect: "none",
        width: size,
      },
    };
  },
);
